import { ReactNode } from 'react'

export enum SectorsWeEngineerItemId {
  Construction = 'Construction and trades',
  Automotive = 'Automotive dealer groups',
  Healthcare = 'Healthcare and multi-site operators',
  Workforce = 'Workforce-heavy operations',
  SupplyChain = 'Supply chain and logistics',
  Saas = 'SaaS and vertical software builders',
}

// Project links render as text, not logos: the two records that carry our
// construction and healthcare proof have no logo asset, and a named link is
// readable by a crawler in a way an <img> never is.
type ProjectLink = {
  id: string
  name: string
  slug: string
}

export type SectorsWeEngineerItem = {
  id: SectorsWeEngineerItemId
  icon: () => ReactNode
  title: string
  description: string
  projectLinks: ProjectLink[]
}
